module.exports = __webpack_public_path__ + "img/olivia.ee54073c.jpg";